import { Main } from './components';

function App() {
  return <Main />;
}

export default App;
